import {useEffect, useState} from "react";

const PAGE_SIZE = 10;

export default (props) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [activities, setActivities] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);

    const fetchActivities = async (page) => {
        setLoading(true);
        try {

            const res = props.ctx.ajax(window.config.api + "/profile/all_buys/" + page, {
                authToken: props.ctx.auth
            }).then(function (data) {
                setActivities(data || []);
                setTotalPages(5);
            })

        } catch (e) {
            console.error("خطا در دریافت اطلاعات:", e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchActivities(currentPage);
    }, [currentPage]);

    const renderStatus = (status) => {
        switch (status) {
            case 0:
                return "در انتظار بررسی";
            case 1:
                return "تایید شده";
            case 2:
                return "رد شده";
            default:
                return "نامشخص";
        }
    };

    return (
        <div className="container mt-4 mb-4">
            <h5 className="mb-4">واریزی‌های من</h5>

            {activities.length === 0 ? (
                <p className="text-muted">هیچ واریزی‌ای ثبت نشده است.</p>
            ) : (
                <>
                    <div className="table-responsive">
                        <table className="table table-bordered text-center align-middle">
                            <thead className="table-light">
                            <tr>
                                <th>#</th>
                                <th>نوع</th>
                                <th>مبلغ</th>
                                <th>تاریخ</th>
                                <th>وضعیت</th>
                                <th>جزئیات</th>
                            </tr>
                            </thead>
                            <tbody>
                            {activities.map((item, idx) => (
                                <tr key={item.id}>
                                    <td>{(currentPage - 1) * PAGE_SIZE + idx + 1}</td>
                                    <td>{item.mode}</td>
                                    <td>{item.amount.toLocaleString()} {item.mode === "TOM" ? "تومان" : "تتر"}</td>
                                    <td>{new Date(item.timestamp * 1000).toLocaleString("fa-IR")}</td>
                                    <td>{renderStatus(item.status)}</td>
                                    <td>
                                        {item.mode === "TOM" ? (
                                            <>
                                                <div><strong>کارت:</strong> {item.sourceCart || "ثبت نشده"}</div>
                                                <div><strong>بانک:</strong> {item.sourceBank || "ثبت نشده"}</div>
                                            </>
                                        ) : (
                                            <>
                                                <div><strong>از ولت:</strong> {item.fromWallet || "ثبت نشده"}</div>
                                                <div><strong>به ولت:</strong> {item.toWallet || "ثبت نشده"}</div>
                                                <div><strong>هش:</strong> {item.hashPay || "ثبت نشده"}</div>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}

                </>
            )}
            <nav>
                <ul className="pagination justify-content-center mt-3">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button
                            className="page-link"
                            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                        >
                            قبلی
                        </button>
                    </li>

                    <li className="page-item   active">
                                <span className="page-link">
                                    صفحه {currentPage}
                                </span>
                    </li>

                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                        <button
                            className="page-link"
                            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages}
                        >
                            بعدی
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    );
};
